module.exports = __webpack_public_path__ + "img/exhibition_tape.16bb3e0f.jpg";